import WebsiteModal from "./WebsiteModal";

export default class TestimonialModal extends WebsiteModal {
    constructor($testimonial) {
        super();

        this.$testimonial = $testimonial;
    }

    buildElement() {
        const $testimonial = this.$testimonial;

        $testimonial.attr("class", "testimonial testimonial--modal");

        let modal_modifier = '';

        if ($testimonial.has('.testimonial__img').length === 0) {
            modal_modifier = "modal--dark-blue-cross";
        }

        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--no-border-top " + modal_modifier}, [
                eotwJSXFactory('div', {className: "modal__bg"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {type: "button", className: "modal__close js-close-modal"}),
                    $testimonial
                ])
            ])
        );
    }
}